import {
  Box,
  Button,
  Center,
  Container,
  Flex,
  HStack,
  Portal,
  Spacer,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  VStack
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsChevronRight, BsPlus } from "react-icons/bs";
import { NumericFormat } from "react-number-format";
import { useNavigate, useParams } from "react-router-dom";
import { IGetSponsors } from "../../../models/admin/sponsors.model";
import Adminroutes from "../../../pages/admin/routes";
import SponsorService from "../../../services/admin/sponsors.service";
import ExportExcel from "../../../utils/ExportExcel";

import { HiOutlinePencil } from "react-icons/hi";
import { IsponsoreTrainees } from "../../../models/admin/sponsored-trainees.model";
import AdminDashboardHeader from "../AdminHeader";
import AdminSidebar from "../AdminSidebar";
import { EditUserModal } from "../EditUserModal";
import { CreateBudgetModal } from "./CreateBudgetModal";
import { PayBudgetModal } from "./PayBudget";

export const ExcelDataExport = [
  {
    "S/N": "1",
    "First Name": "Bolaji",
    "Last Name": "Muili",
    Email: "bolajimuili@gmail.com",
    Phone: "08126684339",
    DOB: "17-12-2002",
    Gender: "Male",
    "Course Code": "ASEOC",
    "Sponsor Code": "j6UPCW",
    "Centre Code": "MCAM",
    "Session Code": "2223",
    "Semester Code": "FQ",
  },
];

const EachSponsor = () => {
  const navigate = useNavigate();
  const [isBudget, setIsBudget] = useState(false);
  const [isPay, setIsPay] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(true);

  const { sponsor_id } = useParams();
  const [sponsor, setSponsor] = useState<IGetSponsors>();

  const [sponsorTrainees, setSponsorTrainees] = useState<IsponsoreTrainees[]>();
  const [sponsorTrainee, setSponsorTrainee] = useState<IsponsoreTrainees>();
  const [budgetAmount, setBudgetAmount] = useState<number>(0);
  const [totalPaid, setTotalPaid] = useState<number>(0);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    SponsorService.getEachSponsor(sponsor_id)
      .then((res) => {
        setSponsor(res);
        
        setLoading(false);
        const budgetAmount: number[] = [];
        res.budgets.forEach((budget) =>
          budgetAmount.push(parseFloat(budget.amount))
        );
        const totalBudget = budgetAmount.reduce((a, b) => a + b, 0);
        setBudgetAmount(totalBudget);

        const paidBudget: number[] = [];
        res.budgets.forEach((budget) =>
          paidBudget.push(parseFloat(budget.paid))
        );
        const totalPaid = paidBudget.reduce((a, b) => a + b, 0);
        setTotalPaid(totalPaid);
      })
      .catch((err) => err);
    SponsorService.getSponsoredTrainees(sponsor_id)
      .then((res) => {
        setSponsorTrainees(res.data);
        
      })
      .catch((err) => err);
  }, [reload]);

  const openBudgetModal = async () => {
    setIsBudget(true);
    setIsUser(false);
    setIsPay(false);
    onOpen();
  };
  const openEditUserModal = async (userDetails: IsponsoreTrainees) => {
    setIsBudget(false);
    setIsUser(true);
    setSponsorTrainee(userDetails);
    
    setIsPay(false);
    onOpen();
  };
  const reloadData = () => {
    setReload(!reload);
    setSponsorTrainee(undefined);
  };

  const uploadTrainees = async () => {
    if (sponsor_id)
      navigate(Adminroutes.sponsor.UploadTraineesLink(sponsor_id));
  };
  const viewBudgets = async () => {
    if (sponsor_id) navigate(Adminroutes.sponsor.sponsorBudgetLink(sponsor_id));
  };

  return (
    <>
      <Flex>
        <Box width="18%" position="fixed" top="0" left="0" zIndex="1">
          <AdminSidebar />
        </Box>
        <Box width="82%" ml="18%">
          <AdminDashboardHeader />
          <Box bg="#F9F8F8" height="100%" pr="3%" pt="30px" pl="40px">
            <Flex justifyContent="space-between" alignItems="center" py="26px">
              <HStack spacing="5px">
                <Text
                  color="#2B2B2B"
                  fontWeight="500"
                  fontSize="16px"
                  cursor="pointer"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {" "}
                  Sponsor
                </Text>
                <BsChevronRight />
                <Text
                  color="#EC3337"
                  fontWeight="400"
                  fontSize="16px"
                  textTransform="capitalize"
                >
                  {" "}
                  {sponsor?.organization_name
                    ? sponsor.organization_name
                    : "nil"}
                </Text>
              </HStack>
              <Button colorScheme="red">
                <a target="__blank" href={`mailto:${sponsor?.email}`}>
                  {" "}
                  Send mail
                </a>
              </Button>
            </Flex>
            <Flex justifyContent="space-between" pb="20px" mb="20px">
              <Container
                bg="white"
                borderRadius="5px"
                pl="50px"
                pr="70px"
                py={2}
                boxShadow="base"
                m={0}
              >
                <VStack pb={2} pt={1}>
                  <Text color="#353535" fontSize="30px" fontWeight="700">
                    {sponsor?.organization_name
                      ? sponsor.organization_name
                      : "Nil"}
                  </Text>
                  <Text color="#959595" fontWeight="500" fontSize="20px">
                    CODE - {sponsor?.code ? sponsor.code : "Nil"}
                  </Text>
                </VStack>
              </Container>

              <Spacer mx={3} />
              <Container
                px={10}
                py={5}
                borderRadius="5px"
                boxShadow="base"
                width="50%"
                bg="white"
                m={0}
              >
                <VStack pb={3} pt={1}>
                  <HStack spacing={3}>
                    <Text color="#959595" fontSize="14px">
                      Total Trainees
                    </Text>
                  </HStack>
                  <Text color="#353535" fontWeight="semibold" fontSize={30}>
                    {sponsorTrainees?.length}
                  </Text>
                </VStack>
              </Container>

              <Spacer mx={3} />

              <Container
                px={10}
                py={5}
                borderRadius="5px"
                boxShadow="base"
                width="50%"
                bg="white"
                m={0}
              >
                <VStack pb={3} pt={1}>
                  <Text color="#959595" fontSize="14px">
                    {" "}
                    Wallet
                  </Text>
                  <Text color="#353535" fontWeight="700" fontSize={20}>
                    <NumericFormat
                      value={totalPaid}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </Text>
                </VStack>
              </Container>
              <Spacer mx={3} />
              <Container
                px={10}
                py={5}
                borderRadius="5px"
                boxShadow="base"
                width="50%"
                bg="white"
                m={0}
              >
                <VStack pb={3} pt={1}>
                  <Box
                    cursor="pointer"
                    onClick={() => {
                      viewBudgets();
                    }}
                  >
                    <Text color="#959595" fontSize="14px">
                      {" "}
                      Budget
                    </Text>
                    <Text color="#353535" fontWeight="700" fontSize={20}>
                      <NumericFormat
                        value={budgetAmount}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </Text>
                  </Box>
                  <HStack
                    spacing="5px"
                    cursor="pointer"
                    fontWeight="700"
                    onClick={() => {
                      openBudgetModal();
                    }}
                    fontSize="12px"
                    color="#EC3337"
                  >
                    <BsPlus />
                    {sponsor && sponsor?.budgets?.length > 0 ? (
                      <Text>Add Budget</Text>
                    ) : (
                      <Text>Create Budget</Text>
                    )}
                  </HStack>
                  <HStack
                    spacing="5px"
                    cursor="pointer"
                    fontWeight="700"
                    onClick={() => {
                      viewBudgets();
                    }}
                    fontSize="12px"
                    color="#EC3337"
                  >
                    <BsPlus />

                    <Text>View Budgets</Text>
                  </HStack>
                </VStack>
              </Container>
            </Flex>
            {sponsorTrainees && sponsorTrainees.length < 0 ? (
              <Box pl="48px" pt="32px" width="100%" bg="white" pb="80px">
                <Flex mb="90px" justifyContent="space-between">
                  <Text
                    textAlign="center"
                    fontWeight="500"
                    fontSize="20px"
                    color="#2B2B2B"
                  >
                    No trainees yet
                  </Text>
                  <ExportExcel
                    title='Download Trainee Template'
                    excelData={ExcelDataExport}
                    fileName={"Trainee Template"}
                  />
                </Flex>
                <Text
                  textAlign="center"
                  mt="10px"
                  fontWeight="400"
                  onClick={() => {
                    uploadTrainees();
                  }}
                  fontSize="14px"
                  color="#EC3337"
                  cursor="pointer"
                >
                  Add Trainees
                </Text>
              </Box>
            ) : (
              <Box
                pl="48px"
                pt="12px"
                pr={"20px"}
                width="100%"
                bg="white"
                pb="40px"
              >
                <Flex mb="90px" justifyContent="space-between">
                  <Text
                    textAlign="center"
                    fontWeight="500"
                    fontSize="20px"
                    color="#2B2B2B"
                  >
                    Sponsored Trainees
                  </Text>
                  <Flex>
                    <Button
                      mr={3}
                      borderRadius={2}
                      colorScheme="red"
                      size="sm"
                      fontSize={12}
                      onClick={() => {
                        uploadTrainees();
                      }}
                    >
                      Add Trainees
                    </Button>
                    <ExportExcel
                      title='Download Template'
                      excelData={ExcelDataExport}
                      fileName={"Trainee Template"}
                    />
                  </Flex>
                </Flex>
                <TableContainer>
                  <Table variant="simple" size="sm">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        fontSize="14px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">Trainee</Th>
                        <Th textTransform="none">Email</Th>
                        <Th textTransform="none">Course Enrolled</Th>
                        <Th textTransform="none">Course Cost</Th>
                        {/* <Th textTransform="none">Action</Th> */}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {sponsorTrainees &&
                        sponsorTrainees.map((each, index) => (
                          <Tr key={index} bg="white" fontSize="14px">
                            <Td>
                              <Text textTransform="capitalize">
                                {each.user.name}
                              </Text>
                            </Td>
                            <Td>{each.user.email}</Td>

                            <Td>
                              {" "}
                              <Text>
                                {each.course.name.substring(0, 30)}...
                              </Text>
                            </Td>
                            <Td>
                              {" "}
                              <Text
                                fontWeight="700"
                                fontSize="14px"
                                color="#616161"
                              >
                                <NumericFormat
                                  value={each?.course.cost}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"₦"}
                                />
                              </Text>
                            </Td>
                            {/* <Td>
                              <Center
                                border="1px solid"
                                borderRadius="10px"
                                borderColor="#E5E5E5"
                                width="30px"
                                onClick={() => {
                                  openEditUserModal(each);
                                }}
                                height="30px"
                              >
                                <HiOutlinePencil />
                              </Center>
                            </Td> */}
                          </Tr>
                        ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Box>
        </Box>
      </Flex>
      {isBudget && (
        <Portal>
          {" "}
          <CreateBudgetModal
            isOpen={isOpen}
            onClosed={onClose}
            isBudget={isBudget}
            sponsorId={sponsor_id}
            reload={reloadData}
          />{" "}
        </Portal>
      )}
      {isPay && (
        <Portal>
          {" "}
          <PayBudgetModal
            isOpenPay={isOpen}
            onClosePay={onClose}
            budgetId={""}
            isPay={isPay}
          />{" "}
        </Portal>
      )}
      {isUser && (
        <Portal>
          {" "}
          <EditUserModal
            isOpen={isOpen}
            onClosed={onClose}
            isUser={isUser}
            userDetails={sponsorTrainee}
            reload={reloadData}
          />{" "}
        </Portal>
      )}
    </>
  );
};

export default EachSponsor;
